import { MentorBase } from '../types/mentor'

// Fisher–Yates shuffle algorithm
function shuffleArray<T>(array: T[]): T[] {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]]
  }
  return array
}

export const reorganizeMentors = (
  allMentors: MentorBase[],
  featuredMentors: MentorBase[],
  selectedMentor?: MentorBase | null,
): MentorBase[] => {
  const idsToRemove = new Set(featuredMentors.map(item => item.mentorId))
  if (selectedMentor) {
    idsToRemove.add(selectedMentor.mentorId)
  }
  const filteredArray = allMentors.filter(
    item => !idsToRemove.has(item.mentorId),
  )

  if (
    selectedMentor &&
    !featuredMentors.some(mentor => mentor.mentorId === selectedMentor.mentorId)
  ) {
    featuredMentors.push(selectedMentor)
  }

  return [...featuredMentors, ...shuffleArray(filteredArray)]
}
